var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.userQueried)?_c('content-loader',{attrs:{"message":_vm.$t('initializing'),"cover":""}}):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }